module.exports = __webpack_public_path__ + "static/media/glasses.5c14c49e.svg";